import { Component, EventEmitter, Output } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AngularModule } from '../../../modules/angular.module';
import { ZorroModule } from '../../../modules/zorro.module';
import { SectionService } from '../../../services/section.service';
import { Section } from '@mira-avant/mtlibs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
	selector: 'app-section-self-roster',
	imports: [AngularModule, NzIconModule, ZorroModule, NzSpinModule],
	standalone: true,
	templateUrl: './section-self-roster.html',
	styleUrl: './section-self-roster.scss',
})
export class SectionSelfRoster {
	@Output('onSectionsChanged') public onSectionsChangedEmitter = new EventEmitter<void>();

	public showForm: boolean = false;
	public sectionCode: string = '';
	public loading: boolean = false;

	constructor(
		private sectionService: SectionService,
		private messageService: NzMessageService
	) {}

	public toggleShowForm(): void {
		this.showForm = !this.showForm;
	}

	public addSection(): void {
		this.loading = true;

		this.sectionService
			.selfRosterStudentToSection$(this.sectionCode)
			.then(() => {
				this.messageService.success(
					'Enrolled in class successfully. You can use the back button in the header to see your class list.'
				);
				this.onSectionsChangedEmitter.emit();
			})
			.catch(error => {
				this.messageService.error(
					'Failed to enroll in class please try again later or check the class / section code.'
				);
			})
			.finally(() => {
				this.loading = false;
				this.sectionCode = '';
				this.showForm = false;
			});
	}
}
